export default function shouldDisableViewRoundNavigation({
  arena_in_progress,
  arena_rolled,
  outstanding_rolls,
  arena_extra_ready = false,
  arena_extra_action = 0,
}) {
  const isExtraAttackPhase = arena_extra_ready || arena_extra_action > 0

  if (!arena_rolled || outstanding_rolls) {
    return true
  }

  if (!arena_in_progress && !isExtraAttackPhase) {
    return true
  }

  return false
}
